export default "__VITE_ASSET__D$lB7K$0__"